module.exports = __webpack_public_path__ + "static/media/211EC257.e2200f1f.jpg";